import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Renderer2
} from '@angular/core';
import {
  ActivatedRoute
} from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'dialog-box',
  templateUrl: 'dialog-box.component.html',
  styleUrls: ["../../../../assets/css/common.css"]
})
export class DialogBoxComponent implements OnInit,OnDestroy {
  @Input() title: string;
  @Input() content: string;
  returnUrl: string;
  modalRef: BsModalRef; 
  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private renderer: Renderer2
  ) {
  }
  hide(){
    this.modalService.hide(1);
   // this.renderer.removeClass(document.body, 'modal-open');


  }
  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  ngOnDestroy()
  {
    this.renderer.removeClass(document.body,'modal-open');
  }
}
